import { CompositeSourcePack, FindFormatCommand, FormatVO, FreedataCall, UserContextService } from '@wizeoo/akm-common-lib';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { CODE_SPACE,  CONFIRMATION_MODE,
  CONFIRMATION_RESULT,  VALUE_ENTER,   WizMathUtils, WizStringUtils, WIZ_COMMAND_STATE,
  WIZ_EVENT_TYPE, WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import {
  ConfirmationResultObj,
  FilterComponent,
  WizButton,
  WizCheckbox,
  WizComponentManager,
  WizDatasource,
  WizDateField,
  WizDropdown,
  WizFocusManager,
  WizGroupCommand,
  WizHgroup,
  WizIcon,
  WizImage,
  WizLabel,
  WizNumericInput,
  WizPopUp,
  WizRoot,
  WizTextarea,
  WizTextInput,
  WizTranslationBasic,
  WizTree,
  WizValidationContainerDirective,
  WizValidationError,
  WizValidationErrors,
  WizValidatorFn,
  WizVgroup,
  WizCommandManager,
  BATCH_FILE_FORMAT,
  ImageUploadParameter,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { PermissionAccess } from '@wizeoo/akm-common-lib';
import { AgLabelValidityRenderer } from '@wizeoo/akm-common-lib';
import { BATCH_KIND } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { ModelExampleVO } from '@wizeoo/akm-common-lib';
import { FakeVO } from '@wizeoo/akm-common-lib';
import { FreedataArgsVO } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { Model } from '../../model/model';
import { ViewData } from '@wizeoo/akm-common-lib';
import { FreeDataVO } from '@wizeoo/akm-common-lib';
import { FreedataLevelVO } from '@wizeoo/akm-common-lib';
import { LanguageCmd } from '@wizeoo/akm-common-lib';
import { MultiDisplay, MultiDisplayConfig } from '@wizeoo/akm-common-lib';
import { PermissionVisibility, StaticFeatureEnum } from '@wizeoo/akm-common-lib';
import { FreedataValueVO } from '@wizeoo/akm-common-lib';
import { FreedataValueCodePop } from './pops/fdv-code.pop';
import { AgFreedataExampleActionRenderer } from './renderers/action/ag-freedata-example-action.renderer';
import { ArgEditorData, ArgsRenderer } from '@wizeoo/akm-common-lib';
import { FDLevelRenderer } from './renderers/fd-level.renderer';
import { FreedataValueTreeRenderer } from './renderers/fdvalue-tree.renderer';
import { MdFreedataExampleTileRenderer } from './renderers/md-freedata-example-tile.renderer';
import { MdFreedataTileRenderer } from './renderers/md-freedata-tile.renderer';
import { ArgAddPop } from './pops/arg.add.pop';
import { FIELD_KIND, EM_ACTION } from '@wizeoo/akm-compute-lib';


/**
 * vue de gestion des FreeDatas / FreeDataValues et levels
 */
@Component({
  selector: 'freedata-view',
  templateUrl: './freedata.view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreedataView extends BaseView {
  /**
   * Constructeur
   * @param elementRef vue phy
   */
  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super(elementRef);
  }

  private get _context(): UserContextService {
    return Model.getInstance().userContextService;
  }

  /* ################################################
                      COMPOSANTS
    ################################################ */

  @ViewChild('multiDisplay', { read: MultiDisplay, static: false }) multiDisplay: MultiDisplay<FreeDataVO>;
  /** Bouton d'export */
  @ViewChild('btnExport', { read: WizIcon, static: false }) btnExport: WizIcon;
  /** Bouton d'import */
  @ViewChild('btnImport', { read: WizIcon, static: false }) btnImport: WizIcon;
  /** Bouton de suppression */
  @ViewChild('btnDelete', { read: WizIcon, static: false }) btnDelete: WizIcon;
  @ViewChild('lblMoreDetail', { read: WizLabel, static: false }) lblMoreDetail: WizLabel; // label du bouton de switch args / fdvs


  /** Arbre des éléments */
  @ViewChild('treeFreeDataValues', { read: WizTree, static: false }) treeFreeDataValues: WizTree<FreedataValueVO>;
  /** le composant de filtre du tree  */
  @ViewChild('fdValuesFilter', { read: FilterComponent, static: false }) fdValuesFilter: FilterComponent;
  /** Bouton d'ajout de free data */
  @ViewChild('btnCreate', { read: WizIcon }) btnCreate: WizIcon;
  /** Bouton de sauvegarde du free data */
  @ViewChild('btnSave', { read: WizButton }) btnSave: WizButton;
  /** Bouton d'annulation */
  @ViewChild('btnCancel', { read: WizButton }) btnCancel: WizButton;

  @ViewChild('vgDetailZone', { read: WizVgroup }) vgDetailZone: WizVgroup; // zone d'édition
  @ViewChild('vgEdition', { read: WizHgroup }) vgEdition: WizHgroup; // zone d'édition
  @ViewChild('vgFDVEdition', { read: WizHgroup }) vgFDVEdition: WizHgroup; // zone d'édition des FDVs
  @ViewChild('vgFDLEdition', { read: WizVgroup }) vgFDLEdition: WizVgroup; // zone d'édition des levels

  @ViewChild('vgNoFreeData', { read: WizVgroup }) vgNoFreeData: WizVgroup; // zone "pas de FD"
  // container d'ajout des niveaux de FDs
  @ViewChild('containerLevels', { read: ViewContainerRef, static: true }) containerLevels: ViewContainerRef; // container d'ajout des levels

  @ViewChild('tiCode', { read: WizTextInput }) tiCode: WizTextInput; // champ de saisie du code
  @ViewChild('trsLabel', { read: WizTranslationBasic }) trsLabel: WizTranslationBasic; // libellé traduit
  /** Composant de sélection de la date de début */
  @ViewChild('dfStartDate', { read: WizDateField }) dfStartDate: WizDateField;
  /** Composant de sélection de la date de fin */
  @ViewChild('dfEndDate', { read: WizDateField }) dfEndDate: WizDateField;
  /** Composant de sélection de la description */
  // @ViewChild('trsDesc', { read: WizTranslationInput }) trsDesc: WizTranslationInput;
  @ViewChild('trsDesc', { read: WizTranslationBasic }) trsDesc: WizTranslationBasic;
  /** Composant de sélection de l'icone */
  @ViewChild('uploadFD', { read: WizImage }) uploadFD: WizImage;
  @ViewChild('cbKindMeasure', { read: WizCheckbox }) cbKindMeasure: WizCheckbox; // CB mesure
  @ViewChild('cbKindWild', { read: WizCheckbox }) cbKindWild: WizCheckbox; // CB wild
  @ViewChild('ddlDatatype', { read: WizDropdown }) ddlDatatype: WizDropdown; // drop de type de données

  @ViewChild('tiDefaultValue', { read: WizTextInput }) tiDefaultValue: WizTextInput; // valeur par défaut
  @ViewChild('tiDefaultTrigger', { read: WizTextInput }) tiDefaultTrigger: WizTextInput; // déclencheur des valeurs par défaut


  /** champ d'affichage du code du FDV */
  @ViewChild('tiValueCode', { read: WizTextInput }) tiValueCode: WizTextInput;
  /** Champ de saisie du code court */
  @ViewChild('tiValueShortCode', { read: WizTextInput }) tiValueShortCode: WizTextInput;
  /** valeur du FDV */
  @ViewChild('tiValueValue', { read: WizTextInput }) tiValueValue: WizTextInput;
  // @ViewChild('trsValueLabel', { read: WizTranslationInput }) trsValueLabel: WizTranslationInput;
  @ViewChild('trsValueLabel', { read: WizTranslationBasic }) trsValueLabel: WizTranslationBasic;
  /** date de début des valeurs */
  @ViewChild('dfValueStartDate', { read: WizDateField }) dfValueStartDate: WizDateField;
  /** date de fin des valeurs */
  @ViewChild('dfValueEndDate', { read: WizDateField }) dfValueEndDate: WizDateField;
  /** Champ de saisie de la description des valeurs */
  // @ViewChild('trsValueDesc', { read: WizTranslationInput }) trsValueDesc: WizTranslationInput;
  @ViewChild('trsValueDesc', { read: WizTranslationBasic }) trsValueDesc: WizTranslationBasic;
  /** Composant de sélection de l'icone des values */
  @ViewChild('uploadFDV', { read: WizImage }) uploadFDV: WizImage;
  /** Composant de suppression sélection de l'icone des values */
  @ViewChild('clearFDV', { read: WizIcon }) clearFDV: WizIcon;


  /** Zone de validation des champs de saisie */
  @ViewChild('hgCodeLabel', { read: WizValidationContainerDirective, static: false })
  private hgCodeLabelContainer: WizValidationContainerDirective;
  /** Zone de validation des champs de saisie de l'élément */
  @ViewChild('vgEditValue', { read: WizValidationContainerDirective, static: false })
  private vgEditValueContainer: WizValidationContainerDirective;

  /** code externe du FD */
  @ViewChild('tiExternalCode', { read: WizTextInput }) tiExternalCode: WizTextInput;
  @ViewChild('tiValueExternalCode', { read: WizTextInput }) tiValueExternalCode: WizTextInput;
  @ViewChild('tiValueExternalParentCode', { read: WizTextInput }) tiValueExternalParentCode: WizTextInput;

  @ViewChild('tiValueRestrict', { read: WizTextarea }) tiValueRestrict: WizTextarea; // expression de restriction
  @ViewChild('niOrder', { read: WizNumericInput }) niOrder: WizNumericInput; // ordre dans le parent
  @ViewChild('cbValueDeprecated', { read: WizCheckbox }) cbValueDeprecated: WizCheckbox; // value deprecated


  /** gestion des args */
  @ViewChild('argsMultiDisplay', { read: MultiDisplay, static: false }) argsMultiDisplay: MultiDisplay<FreeDataVO>;

  /** Zone de validation des champs de saisie de l'élément */
  @ViewChild('vgEditArgs', { read: WizVgroup }) vgEditArgs: WizVgroup; // zone d'édition des args
  @ViewChild('vgEditArgs', { read: WizValidationContainerDirective, static: false })
  private vgEditArgsContainer: WizValidationContainerDirective;
  @ViewChild('tiArgShortCode', { read: WizTextInput }) tiArgShortCode: WizTextInput; // code du field
  @ViewChild('trsArgLabel', { read: WizTranslationBasic }) trsArgLabel: WizTranslationBasic; // libellé du champ
  @ViewChild('ddlArgDatatype', { read: WizDropdown }) ddlArgDatatype: WizDropdown; // drop de type de données
  @ViewChild('ddlArgFormat', { read: WizDropdown }) ddlArgFormat: WizDropdown; // drop du format de données
  @ViewChild('tiArgRestrict', { read: WizTextarea }) tiArgRestrict: WizTextarea; // expression de restriction
  @ViewChild('tiArgLock', { read: WizTextarea }) tiArgLock: WizTextarea; // expression de lock (comme restriction mais pas masqué)
  @ViewChild('tiArgValidator', { read: WizTextarea }) tiArgValidator: WizTextarea; // fonction de validation
  @ViewChild('tiArgSource', { read: WizTextInput }) tiArgSource: WizTextInput; // FD source de données en cas de liste
  @ViewChild('tiArgDefaultValue', { read: WizTextInput }) tiArgDefaultValue: WizTextInput; // valeur par défaut
  @ViewChild('tiArgDefaultTrigger', { read: WizTextInput }) tiArgDefaultTrigger: WizTextInput; // déclencheur des valeurs par défaut
  @ViewChild('tiArgAction', { read: WizTextInput }) tiArgAction: WizTextInput; // akConnect à exécuter
  @ViewChild('niArgSize', { read: WizNumericInput }) niArgSize: WizNumericInput; // taille du champ par défaut en mode liste
  @ViewChild('trsRestrictMsg', { read: WizTranslationBasic }) trsRestrictMsg: WizTranslationBasic; // msg erreur sur restrict
  @ViewChild('trsValueControlMsg', { read: WizTranslationBasic }) trsValueControlMsg: WizTranslationBasic; // msg erreur sur badValue
  @ViewChild('taArgSettings', { read: WizTextarea }) taArgSettings: WizTextarea; // settings
  
  @ViewChild('tiRegex', { read: WizTextInput }) tiRegex: WizTextInput; // restrictions en saisie sur le texte
  @ViewChild('cbUpper', { read: WizCheckbox }) cbUpper: WizCheckbox; // forcer les majuscules
  @ViewChild('tiMinVal', { read: WizTextInput }) tiMinVal: WizTextInput; // fonction de validation
  @ViewChild('tiMaxVal', { read: WizTextInput }) tiMaxVal: WizTextInput; // fonction de validation
  

  @ViewChild('vgFDVArgs', { read: WizVgroup }) vgFDVArgs: WizVgroup; // zone d'édition des champs complémtaires des FDVs
  @ViewChild('containerFdvArgs', { read: ViewContainerRef, static: true }) containerFdvArgs: ViewContainerRef; // container d'ajout des champs complémentaires


  /* ################################################
                      PROPRIETES
   ################################################ */

  /** Renderer du tree des FREEDATA_VALUES */
  public valuesTreeRenderer: any = FreedataValueTreeRenderer;

  // mode édition, simplement l'entête (ou pas)
  public get showEditionZone(): boolean {
    return (
      !!this.clone &&
      Model.getInstance().permissionEngine.hasAnyPermission({
        feature: StaticFeatureEnum.FREEDATA,
        accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE, PermissionAccess.READ],
        visibility: PermissionVisibility.DISABLED,
      })
    );
  }

  public moreArgsMode: boolean = false; // affichage des champs complémentaires
  public get moreAgrsLabel(): string { // libellé du bouton de bascule args / values
    if (this.moreArgsMode) {
      return '$.freedata.morevalues.$';
    }
    return '$.freedata.moreargs.$';
  }

  public get showArgsEditZone(): boolean { // affichage de la zone d'édition des fields
    return !!this.currentArg;
  }

  public get showArgDelete(): boolean { // affichage de l'icone delete des args
    return !!this.currentArg;
  }


  //affichage spécifique pour les séquence
  public get showSequenceMode(): boolean {
    return !!this.clone?.kindWild;
  }

  // édition des FDV (en plus de l'entête)
  public get showDetailZone(): boolean {
    return (
      !this.moreArgsMode && // pas en mode complément
      !!this.clone &&
      this.clone.exist &&
      Model.getInstance().permissionEngine.hasAnyPermission({
        feature: StaticFeatureEnum.FREEDATA,
        accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE, PermissionAccess.READ],
        visibility: PermissionVisibility.DISABLED,
      })
    );
  }
  public showFDVEditZone: boolean = false; // zone d'édition d'UN FDV (et level)

  /**
   * retourne vrai si le FD porte à minima un champ complémentaire
   */
  public get fdArgs(): boolean {
    return !!this.clone && this.clone.getArgsVO().length > 0;
  }

  public get cantCreateValues(): boolean {
    return (
      !this.clone ||
      !Model.getInstance().permissionEngine.hasAnyPermission({
        feature: StaticFeatureEnum.FREEDATA,
        accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
        visibility: PermissionVisibility.DISABLED,
      })
    );
  }

  /** DS de la drop de types de données */
  public datatypeDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>(ViewData.getInstance().datatypeList)
    .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .build();

  /** DS de la drop de types de données pour les args */
  public argsDatatypeDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>(ViewData.getInstance().moreArgstypeList)
    .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .build();

  /** DS de la drop des formats */
  public argsFormatDS: WizDatasource<FormatVO> = new WizDatasource<FormatVO>([])
    .setFilter(this.dataKindFilter.bind(this))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /**
   * filterFunc de la liste des formats, selon le type du field
   * @param e la fonction
   */
  public dataKindFilter(fm: FormatVO): boolean {
    if (!this.currentArg || !this.currentArg.dataType) {
      return false;
    }

    if (this.currentArg.dataType === FIELD_KIND.FORMULA) { // tous les formats autorisés pour les formules
      return true;
    }

    return fm.dataKind === this.currentArg.dataType;
  }

  /** Data source de l'arbre des éléments de codification' */
  public freedataArgsDS: WizDatasource<FreedataArgsVO> = new WizDatasource<FreedataArgsVO>([])
    .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /**
   * Configuration du mode multi display des args
   */
  public argsMultiConfig: MultiDisplayConfig<FreedataArgsVO> = {
    model: Model.getInstance(),
    datasource: this.freedataArgsDS,
    defaultMode: 'grid',
    onSelectionChanging: this.askSelectArg.bind(this),
    grid: {
      enabled: true,
      columns: [
        { headerName: '$.arg.code.$', width: 100, sortable: true, resizable: true, field: 'code', tooltipField: 'code' },
        { headerName: '$.arg.label.$', minWidth: 50, flex: 1, sortable: true, resizable: true, field: 'trsLabel', tooltipField: 'trsLabel' },
        { headerName: '$.arg.datatype.$', width: 100, sortable: true, resizable: true, field: 'dataType', tooltipField: 'dataType' },
        { headerName: '$.arg.source.$', width: 100, sortable: true, resizable: true, field: 'datas', tooltipField: 'datas' },
        { headerName: '$.arg.format.$', width: 100, sortable: true, resizable: true, field: 'format', tooltipField: 'format' },
        { headerName: '$.arg.restrict.$', width: 100, sortable: true, resizable: true, field: 'restrict', tooltipField: 'restrict' },
        { headerName: '$.arg.validator.$', width: 100, sortable: true, resizable: true, field: 'validator', tooltipField: 'validator' },
        { headerName: '$.arg.valor.$', width: 100, sortable: true, resizable: true, field: 'valor', tooltipField: 'valor' },
        { headerName: '$.arg.action.$', width: 100, sortable: true, resizable: true, field: 'action', tooltipField: 'action' },
        { headerName: '$.arg.size.$', width: 100, sortable: true, resizable: true, field: 'defaultSize', tooltipField: 'defaultSize' },
      ]
    },
    filter: {
      enabled: true,
      initFilter: this.initArgsFilter.bind(this),
    },
  };

  private argsFilter: FilterComponent; // filterCompo de la liste de FD
  private initArgsFilter(pFilter: FilterComponent): FilterComponent {
    this.argsFilter = pFilter;
    this.argsFilter.configure(['code', 'trsLabel', 'dataType'], null, null);
    return this.argsFilter;
  }




  /** Data source du multidisplay (liste des FDs) */
  public freedataDS: WizDatasource<FreeDataVO> = new WizDatasource<FreeDataVO>()
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /**
   * Configuration du mode multi display (principal)
   */
  public multiConfig: MultiDisplayConfig<FreeDataVO> = {
    model: Model.getInstance(),
    datasource: this.freedataDS,
    defaultMode: 'tiles',
    onSelectionChanging: this.askSelectFD.bind(this),
    tiles: { enabled: true, renderer: MdFreedataTileRenderer, itemHeight: 150, itemWidth: 200 },
    grid: {
      enabled: true,
      columns: [
        { headerName: '$.common.code.$', width: 80, sortable: true, field: 'shortCode', tooltipField: 'shortCode' },
        { headerName: '$.common.label.$', minWidth: 120, flex: 1, sortable: true, field: 'trsLabel', cellRenderer: 'labelRenderer' },
        { headerName: '$.common.item.$', width: 80, sortable: true, field: 'childrenCount' },
        {
          headerName: '$.bu.home.application.actions.$',
          field: 'actions',
          width: 70,
          cellRenderer: 'exampleActionRenderer',
        },
      ],
      renderers: {
        exampleActionRenderer: AgFreedataExampleActionRenderer,
        labelRenderer: AgLabelValidityRenderer,
      },
    },
    filter: {
      enabled: true,
      initFilter: this.initFilter.bind(this),
    },
  };

  private mainFilter: FilterComponent; // filterCompo de la liste de FD

  /** Data source de l'arbre des éléments de codification' */
  public freedataValueDS: WizDatasource<FreedataValueVO> = new WizDatasource<FreedataValueVO>([])
    .setHierarchical(true)
    .setItemCodeField('code')
    .setItemParentCodeField('treeParentCode')
    .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
    .setFilter(this.fdvFilterFunc.bind(this))
    .setSelectionMode('single')
    .build();

  /** Data du grid "samples" */
  public sampleDS: WizDatasource<ModelExampleVO> = new WizDatasource<ModelExampleVO>()
    .setSortFields([{ property: 'title', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /**
   * configuration du multi liste des exemples de modèles
   */
  public examplesMultiConfig: MultiDisplayConfig<ModelExampleVO> = {
    model: Model.getInstance(),
    datasource: this.sampleDS,
    defaultMode: 'tiles',
    tiles: { enabled: true, renderer: MdFreedataExampleTileRenderer, itemHeight: 150, itemWidth: 200 },
    grid: {
      enabled: true,
      columns: [
        { headerName: '$.common.code.$', width: 100, sortable: true, field: 'code', tooltipField: 'code' },
        { headerName: '$.common.label.$', minWidth: 150, flex: 1, sortable: true, field: 'trsLabel', cellRenderer: 'labelRenderer' },
        { headerName: '$.common.item.$', width: 80, sortable: true, field: 'childrenCount' },
        {
          headerName: '$.bu.home.application.actions.$',
          field: 'actions',
          width: 80,
          cellRenderer: 'exampleActionRenderer'
        }
      ],
      renderers: {
        exampleActionRenderer: AgFreedataExampleActionRenderer,
        labelRenderer: AgLabelValidityRenderer,
      },
    },
  };

  public clone: FreeDataVO = null; // clone de travail
  private currentFDV: FreedataValueVO = null; // FDV du clone en cours de modif
  private currentFDLevel: FreedataLevelVO = null; // fdLevel du clone en cours de modif

  public currentArg: FreedataArgsVO = null; // field en cours (on travaille sur le clone du FD)

  /** les champs de saisie des niveaux */
  public lvlComponents: ComponentRef<FDLevelRenderer>[] = [];

  /* ################################################
                     appels de service
  ################################################ */

  /**
   * Pretraitement: elaboration de la WizCommand d'initialisation
   * @return WizCommand La commande de recherche des free data
   */
  public wizBeforeInit(): WizGroupCommand {
    super.wizBeforeInit();
    const calls = [];
    // Chargement des langues si vide
    if (!Model.getInstance().languageMap) {
      calls.push(new LanguageCmd(Model.getInstance()).find());
    }
    calls.push(new FreedataCall(Model.getInstance()));

    // chargement de la liste des formats
    if (!Model.getInstance().formatEngine.getFormatList()) {
      // TODO, double appel pour format de base à la bu (*)
      calls.push(new FindFormatCommand(Model.getInstance()).find(ViewData.wildcardDomain, ViewData.wildcardDomain));
      calls.push(new FindFormatCommand(Model.getInstance()).find(Model.getInstance().domainCode, Model.getInstance().businessUnitCode));
    }

    return new WizGroupCommand().configure(calls);
  }

  /* ################################################
                      CYCLE DE VIE
    ################################################ */

  /**
   * Synchronisation des donnees
   */
  public wizSynchronizeData(): void {
    super.managePermissions([
      {
        feature: StaticFeatureEnum.FREEDATA,
        permissions: [
          {
            component: this.btnCreate,
            accesses: [PermissionAccess.CREATE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnDelete,
            accesses: [PermissionAccess.DELETE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnExport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnImport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
        ],
      },
    ]);

    this.tiCode.wizRestrict = ViewData.CODE_REGEXP;
    // this.tiValueCode.wizRestrict = ViewData.CODE_REGEXP;
    this.tiValueShortCode.wizRestrict = ViewData.CODE_REGEXP;
    this.feedDS(); // alimentation des DS
    this.feed(); // alimentation de l'objet principal
  }

  private initFilter(pFilter: FilterComponent): FilterComponent {
    this.mainFilter = pFilter;
    return this.mainFilter;
  }

  /**
   * Alimentation du grid des free data
   */
  private feedDS() {
    // alimente la data source avec les données du model
    this.freedataDS.setSource(Model.getInstance().freedataEngine.getFreeDataList());
    this.freedataDS.setSelectedItems([Model.getInstance().currentEditedFreedata]);

    this.sampleDS.setSource(ViewData.getInstance().fakeFreeDataModel);

    this.mainFilter.configure(['shortCode', 'trsLabel'], null, null); // alimentation du filtre principal
    // le contextEngine prend le relais pour alimenter les filtres par défaut
    this._context.feedFilterContext(this.mainFilter);

    this.fdValuesFilter.configure(['shortCode', 'trsLabel'], null, null); // alimentation du filtre des FDVs
    // le contextEngine prend le relais pour alimenter les filtres par défaut
    this._context.feedFilterContext(this.fdValuesFilter, 'FDV_FILTER');

    this.freedataDS.refresh();
    this.freedataValueDS.refresh();
  }

  /** Suppression des modifications */
  private reset() {
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false));
    this.feed(); // on repart sur un cycle d'affichage de la vue détail
  }

  /** Alimentation de la vue detail avec le clone du FD selectionné */
  private feed(fdvCode: string = null): void {
    this.clone = Model.getInstance().freedataEngine.cloneFD(Model.getInstance().currentEditedFreedata);

    // on rince l'éventuelle currentArg
    this.currentArg = null;

    if (this.clone) {
      // alimentation des champs d'entête
      this.tiCode.wizDisabled = this.clone.exist; // édition du code

      this.tiCode.wizValue = this.clone.shortCode;
      this.tiExternalCode.wizValue = this.clone.externalCode;
      this.trsLabel.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.labelVO);

      this.trsDesc.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.descriptionVO);

      this.dfStartDate.wizNumberValue = this.clone.startDate;
      this.dfEndDate.wizNumberValue = this.clone.endDate;

      this.cbKindMeasure.wizChecked = this.clone.kindMeasure;
      this.cbKindWild.wizChecked = this.clone.kindWild;

      this.uploadFD.sourceObservable = this.clone.iconOrDie;

      this.ddlDatatype.wizDataProvider = this.datatypeDS; // alimentation de la drop des types de données
      let st: FakeVO = null; // le statut en forme "objet"
      if (this.clone.dataType) {
        st = this.datatypeDS.getItemByKey(this.clone.dataType);
      }
      this.datatypeDS.select([st]);

      this.tiDefaultValue.wizValue = this.clone.defaultValue;
      this.tiDefaultTrigger.wizValue = this.clone.defaultTrigger;

      // plus de sélection de FDV
      this.currentFDV = null;
      if (this.freedataValueDS) {
        this.freedataValueDS.clearSelection();
      }


      this.feedFreedataValues(fdvCode);

      this.feedArgsValues();

      this.focusFields();
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false));
    }
    this.manageComponents(); // dans tous les cas, on gère le refresh, même sans clone
  }

  /** Alimentation de l'arbre des FDV */
  private feedFreedataValues(fdvCode: string = null): void {
    if (this.clone.exist) {
      this.freedataValueDS.setSource(this.clone.getValuesVO());
      this.treeFreeDataValues.wizDataProvider = this.freedataValueDS; // alimentation de l'arbre
      // this.freedataValueDS.expandAll();

      if (!!fdvCode) {
        const fdv: FreedataValueVO = this.freedataValueDS.getItemByKey(fdvCode);
        this.currentFDV = fdv;
      }

      this.freedataValueDS.setSelectedItems([this.currentFDV]);

      this.feedFDVFields();
    }
  }

  /** Methode qui change la visibilité des composants */
  private manageComponents(): void {
    if (!!this.clone) {
      this.btnDelete.wizDisabled =
        !this.clone.exist || !Model.getInstance().permissionEngine.canDelete(StaticFeatureEnum.FREEDATA); // pas de suppression sur création
      this.dfStartDate.wizMaxDate = this.dfEndDate.wizDateValue;
      this.dfEndDate.wizMinDate = this.dfStartDate.wizDateValue;
      if (this.clone.exist) {
        this.cbKindMeasure.wizDisabled = true;
        this.cbKindWild.wizDisabled = true;
        this.btnSave.wizLabel = '$.freedata.update.valid.$';
        this.freedataValueDS.refresh(); // les FDVs uniquement si le clone est persisté
      } else {
        this.btnSave.wizLabel = '$.freedata.create.valid.$';
        this.cbKindMeasure.wizDisabled = false;
        this.cbKindWild.wizDisabled = false;
      }
    } else {
      // pas de FD sélectionné
      this.btnDelete.wizDisabled = true;
    }
    // Affichage des boutons en fonction du modelUpdate
    this.btnSave.wizDisabled = !ViewData.wizUpdateModel;
    this.btnCancel.wizDisabled = !ViewData.wizUpdateModel;

  }

  /**
   * focus du champ de saisie de la zone d'édition d'un freedata
   */
  private focusFields(): void {
    if (this.clone.exist) {
      WizFocusManager.getInstance().wizSetFocus(this.trsLabel.mainInput);
    } else {
      // focus de l'input du code si c'est une création
      WizFocusManager.getInstance().wizSetFocus(this.tiCode);
    }
  }

  /** mémorisation du filtre */
  public wizOnDestroy(): void {
    super.wizOnDestroy();
    // this._context.saveLocalFilter(this.mainFilter);
    // this._context.saveLocalFilter(this.fdValuesFilter, 'FDV_FILTER');
  }

  /* ################################################
                     interactions
   ################################################ */

  /** Mise en place des ecouteurs de la vue */
  public wizAddListener(): void {
    super.wizAddListener();
    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);
    WizEventManager.addListener(this, this.vgFDVEdition, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);
    WizEventManager.addListener(this, this.vgFDLEdition, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);
    WizEventManager.addListener(this, this.vgEditArgs, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);

    // mise à jour des champs complémentaires sur les FDVs
    WizEventManager.addListener(this, this.vgFDVArgs, ALK_EVENT_TYPE.FORM_UPDATE, this.updateModelFromFdvArgs);

    // Listener pour les actions sur les boutons
    WizEventManager.addListener(this, this.elementRef, WIZ_EVENT_TYPE.CLICK, this.buttonAction);

    // application du filtre sur tree FDV
    WizEventManager.addListener(this, this.fdValuesFilter, WIZ_EVENT_TYPE.CHANGE, this.refreshFDVList);

    // changement de sélection dans le tree
    WizEventManager.addListener(this, this.treeFreeDataValues, WIZ_EVENT_TYPE.SELECTION_CHANGING, this.askSelectFDV, {
      capture: true,
    });
    WizEventManager.addListener(this, this.treeFreeDataValues, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.selectFDV);
    // Listener sur l'evenement ALK_EVENT_ADD emis lors de la demande de création d'un free data value
    WizEventManager.addListener(this, this.treeFreeDataValues, ALK_EVENT_TYPE.ADD, this.addFDV);
    // Listener sur l'evenement ALK_EVENT_DELETE emis lors de la demande de suppression d'un free data value
    WizEventManager.addListener(this, this.treeFreeDataValues, ALK_EVENT_TYPE.DELETE, this.askdeleteFDV);

    // écoute du retour d'import (batch pour refresh de la vue)
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN, this.backFromImport);

    // écouteur sur demande refresh data  /cache
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.WIDGET_MUST_REFRESH, this.backFromReload);


  }

  /**
   * Suppression des ecouteurs de la vue
   */
  public wizRemoveListener(): void {
    super.wizRemoveListener();
    WizEventManager.removeListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, this.vgFDVEdition, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, this.vgFDLEdition, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, this.vgEditArgs, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, this.vgFDVArgs, ALK_EVENT_TYPE.FORM_UPDATE);


    WizEventManager.removeListener(this, this.elementRef, WIZ_EVENT_TYPE.CLICK);
    WizEventManager.removeListener(this, this.fdValuesFilter, WIZ_EVENT_TYPE.CHANGE);

    WizEventManager.removeListener(this, this.treeFreeDataValues, WIZ_EVENT_TYPE.SELECTION_CHANGING);
    WizEventManager.removeListener(this, this.treeFreeDataValues, WIZ_EVENT_TYPE.SELECTION_CHANGED);
    WizEventManager.removeListener(this, this.treeFreeDataValues, ALK_EVENT_TYPE.ADD);
    WizEventManager.removeListener(this, this.treeFreeDataValues, ALK_EVENT_TYPE.DELETE);

    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN);

    // écouteur sur demande refresh data  /cache
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.WIDGET_MUST_REFRESH);
  }

  /**
   * Handler de clic dans la vue
   * @param event L'evenement declencheur
   */
  private buttonAction(event: WizEvent) {
    switch (event.component) {
      case this.btnSave:
        let errors = this.hgCodeLabelContainer.check(true, true);
        if (this.currentFDV) {
          errors = errors.concat(this.vgEditValueContainer.check(true, true));
        }

        if (this.currentArg) {
          errors = errors.concat(this.vgEditArgsContainer.check(true, true));
        }

        // gestion manuelle des libellés manquant sur level, process de validation marche pas en dynamique...
        // prise du nombre de levels. Si un seul, pas besoin de gérer les noms de niveaux
        const nbLevel: number = this.getMaxLevel();
        if (nbLevel > 1) {
          this.clone.levelsVO.forEach((lvlVO: FreedataLevelVO) => {
            if (lvlVO.level <= nbLevel) {
              if (!lvlVO.trsLabel || lvlVO.trsLabel.length === 0) {
                errors.push({ wizError: 'missing level label', wizErrorParams: [lvlVO.level] });
              }
            }
          });
        }

        // ### contrôle des levels obsolètes
        let lvlRequiredSet: Set<number> = new Set();
        this.clone.getValuesVO().forEach((fdv: FreedataValueVO) => {
          lvlRequiredSet.add(fdv.level);
        })

        const todieLevels: FreedataLevelVO[] = [];
        this.clone.levelsVO.forEach((fdl: FreedataLevelVO) => {
          if (!lvlRequiredSet.has(fdl.level)) {
            todieLevels.push(fdl);
          }
        });

        todieLevels.forEach((fdl: FreedataLevelVO) => {
          Model.getInstance().freedataEngine.removeFreeDataLevel(this.clone, fdl);
          // this.clone.removeFreeDataLevel(fdl);
        });
        // ### fin gestion des levels obsolètes

        if (!errors || errors.length === 0) {

          if (this.clone.exist) {
            const csp: CompositeSourcePack = {
              freedata: this.clone, // update / create / delete sur FDV
              freedataManagement: true, // maj du FD, pas géré sinon
            }
            Model.getInstance().compositeEngine.compositeCommit(csp, this.mergeFromDataCommit.bind(this));
          } else {
            Model.getInstance().freedataEngine.create(this.clone, this.mergeCallback.bind(this));
          }




        } else {
          WizPopUp.toast('$.common.toast.pending.error.$', WizIcon.TOAST_ERROR).show();
        }
        break;
      case this.btnCancel:
        WizPopUp.confirm(
          '$.common.pending.update.title.$',
          '$.common.pending.update.detail.$',
          this.doCancel.bind(this),
          CONFIRMATION_MODE.CONFIRM_CANCEL
        ).show();
        break;
    }
  }

  public doAct(action: string): void {
    const hasPendingChanges = ViewData.wizUpdateModel;
    switch (action) {
      case 'export':
        if (!!Model.getInstance().currentEditedFreedata) {
          if (this.moreArgsMode) {
            Model.getInstance().batchEngine.export(BATCH_KIND.FREEDATAARGS, BATCH_FILE_FORMAT.CSV, Model.getInstance().currentEditedFreedata.code);
          } else {
            Model.getInstance().batchEngine.export(BATCH_KIND.FREEDATA, BATCH_FILE_FORMAT.CSV, Model.getInstance().currentEditedFreedata.code);
          }
        } else {
          Model.getInstance().batchEngine.export(BATCH_KIND.FREEDATA);
        }
        break;
      case 'import':
        Model.getInstance().batchEngine.import(BATCH_KIND.FREEDATA);
        break;
      // case 'importArgs':
      //   Model.getInstance().batchEngine.import(BATCH_KIND.FREEDATAARGS);
      //   break;  
      case 'delete':
        WizPopUp.confirm(
          '$.common.delete.title.$',
          '$.common.delete.detail.$',
          this.deleteFD.bind(this),
          CONFIRMATION_MODE.CONFIRM_CANCEL,
          Model.getInstance().currentEditedFreedata,
          null,
          null
        ).show();
        break;
      case 'create': // demande de create
        if (hasPendingChanges) {
          WizPopUp.confirm(
            '$.common.pending.update.title.$',
            '$.common.pending.update.detail.$',
            this.askForCreate.bind(this),
            CONFIRMATION_MODE.CONFIRM_CANCEL,
            this.clone,
            null,
            null
          ).show();
        } else {
          this.createFD();
        }
        break;
      case 'updateFDVCode':
        this.askForFDVCode();
        break;
      case 'moreArgs': //passage de la vue fields à la vue values
        if (!this.checkArgError()) { // seulement si pas d'erreurs
          this.moreArgsMode = !this.moreArgsMode;
        }
        break;
      case 'deleteArgs':
        WizPopUp.confirm(
          '$.common.delete.title.$',
          '$.common.delete.detail.$',
          this.deleteArg.bind(this),
          CONFIRMATION_MODE.CONFIRM_CANCEL,
          this.currentArg,
          null,
          null
        ).show();
        break;
    }
  }

  /** mise à jour des champs complémentaires sur FDV */
  private updateModelFromFdvArgs(e: AlkEvent): void {

    let data: ArgEditorData = e.data.field;
    let value: string = e.data.value;

    Model.getInstance().freedataEngine.feedFreedataValueField(data.fdv, data.arg.code, value);
    this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
    this.clone.addToUpdatePack(this.currentFDV, EM_ACTION.UPDATE);
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    this.manageComponents();
  }

  /**
   * Modification du model dans la zone de saisie
   * @param e Evenement model change
   */
  private updateModel(e: WizEvent): void {
    // interception des opération sur titre de niveau
    if (e.value instanceof FDLevelRenderer) {
      // identifier le bon level
      this.currentFDLevel = this.clone.levelsVOMap.get(e.value.data.level);
      this.currentFDLevel.labelVO.updateTranslationEntry(e.value.updatedEntry);
    } else {
      switch (e.component) {
        case this.tiCode:
          this.clone.shortCode = this.tiCode.wizValue?.toUpperCase();
          if (!this.clone.exist) {
            this.clone.code = this.tiCode.wizValue?.toUpperCase();
          }
          break;
        case this.tiExternalCode:
          this.clone.externalCode = this.tiExternalCode.wizValue;
          break;
        case this.dfStartDate:
          this.clone.startDate = this.dfStartDate.wizNumberValue;
          this.dfEndDate.wizMinDate = this.dfStartDate.wizDateValue;
          break;
        case this.dfEndDate:
          this.clone.endDate = this.dfEndDate.wizNumberValue;
          this.dfStartDate.wizMaxDate = this.dfEndDate.wizDateValue;
          break;
        case this.trsLabel:
          this.clone.labelVO.updateTranslationEntry(e.value);
          break;
        case this.trsDesc:
          this.clone.descriptionVO.updateTranslationEntry(e.value);
          break;
        case this.uploadFD:
          this.clone.icon = e.value;
          this.uploadFD.sourceObservable = this.clone.iconOrDie; // mise à jour de l'image
          break;
        case this.cbKindMeasure:
          this.clone.kindMeasure = this.cbKindMeasure.wizChecked;
          this.clone.kindWild = false; // soit Measure, soit wild, pas les 2
          this.cbKindWild.wizChecked = false;
          break;
        case this.cbKindWild:
          this.clone.kindWild = this.cbKindWild.wizChecked;
          this.clone.kindMeasure = false; // soit Measure, soit wild, pas les 2
          this.cbKindMeasure.wizChecked = false;
          break;
        case this.ddlDatatype:
          this.clone.dataType = this.ddlDatatype.selectedItem ? this.ddlDatatype.selectedItem.code : null;
          break;
        case this.tiDefaultValue:
          this.clone.defaultValue = this.tiDefaultValue.wizValue;
          break;
        case this.tiDefaultTrigger:
          this.clone.defaultTrigger = this.tiDefaultTrigger.wizValue;
          break;

        // gestion de la section FreedataValue

        case this.tiValueShortCode:
          this.currentFDV.shortCode = this.tiValueShortCode.wizValue?.toUpperCase();
          break;
        case this.tiValueValue:
          this.currentFDV.valor = this.tiValueValue.wizValue;
          break;
        case this.tiValueExternalCode:
          this.currentFDV.externalCode = this.tiValueExternalCode.wizValue;
          break;
        case this.tiValueExternalParentCode:
          this.currentFDV.externalParentCode = this.tiValueExternalParentCode.wizValue;
          break;
        case this.dfValueStartDate:
          this.currentFDV.startDate = this.dfValueStartDate.wizNumberValue;
          this.dfValueEndDate.wizMinDate = this.dfValueStartDate.wizDateValue;
          break;
        case this.dfValueEndDate:
          this.currentFDV.endDate = this.dfValueEndDate.wizNumberValue;
          this.dfValueStartDate.wizMaxDate = this.dfValueEndDate.wizDateValue;
          break;
        case this.trsValueLabel:
          this.currentFDV.labelVO.updateTranslationEntry(e.value);
          break;
        case this.trsValueDesc:
          this.currentFDV.descriptionVO.updateTranslationEntry(e.value);
          break;
        case this.uploadFDV:
          this.currentFDV.icon = e.value;
          this.uploadFDV.sourceObservable = this.currentFDV.iconOrDie; // mise à jour de l'image
          break;
        case this.clearFDV:
          this.currentFDV.icon = null;
          this.uploadFDV.sourceObservable = this.currentFDV.iconOrDie;
          break;
        case this.tiValueRestrict:
          this.currentFDV.restrict = this.tiValueRestrict.wizValue;
          break;
        case this.cbValueDeprecated:
          this.currentFDV.deprecated = this.cbValueDeprecated.wizChecked;
          break;
        case this.niOrder:
          this.currentFDV.order = this.niOrder.wizNumber;
          break;


        // gestion de la section args
        case this.tiArgShortCode:
          this.currentArg.code = this.tiArgShortCode.wizValue?.toUpperCase();
          break;
        case this.trsArgLabel:
          this.currentArg.labelVO.updateTranslationEntry(e.value);
          break;
        case this.trsRestrictMsg:
          this.currentArg.editRestrictMessageVO.updateTranslationEntry(e.value);
          break;
        case this.trsValueControlMsg:
          this.currentArg.valueControlMessageVO.updateTranslationEntry(e.value);
          break;
        case this.ddlArgDatatype:
          this.currentArg.dataType = this.ddlArgDatatype.selectedItem ? this.ddlArgDatatype.selectedItem.code : null;
          this.currentArg.format = null; // TODO refresh de la drop de format ?
          this.argsFormatDS.clearSelection();
          this.argsFormatDS.refresh(); // réactualiser la liste des formats
          break;
        case this.ddlArgFormat:
          this.currentArg.format = this.ddlArgFormat.selectedItem ? this.ddlArgFormat.selectedItem.businessUnitCode + ViewData.KEY_SEPARATOR + this.ddlArgFormat.selectedItem.code : null;
          break;

        case this.tiArgRestrict:
          this.currentArg.restrict = this.tiArgRestrict.wizValue;
          break;
        case this.tiArgLock:
          this.currentArg.lock = this.tiArgLock.wizValue;
          break;
        case this.tiArgValidator:
          this.currentArg.validator = this.tiArgValidator.wizValue;
          break;
        case this.tiArgSource:
          this.currentArg.datas = this.tiArgSource.wizValue;
          break;
        case this.tiArgDefaultValue:
          this.currentArg.valor = this.tiArgDefaultValue.wizValue;
          break;
        case this.tiArgDefaultTrigger:
          this.currentArg.valorTrigger = this.tiArgDefaultTrigger.wizValue;
          break;
        case this.tiMinVal:
          this.currentArg.minValue = this.tiMinVal.wizValue;
          break;
        case this.tiMaxVal:
          this.currentArg.maxValue = this.tiMaxVal.wizValue;
          break;
        case this.tiArgAction:
          this.currentArg.action = this.tiArgAction.wizValue;
          break;
        case this.niArgSize:
          this.currentArg.defaultSize = this.niArgSize.wizNumber;
          // console.log('niArg setter', this.niArgSize.wizNumber, this.currentArg.defaultSize);
          break;
        case this.tiRegex:
          this.currentArg.regex = this.tiRegex.wizValue;
          break;
        case this.cbUpper:
          this.currentArg.upper = this.cbUpper.wizChecked;
          break;
        case this.taArgSettings:
          this.currentArg.settingsStr = this.taArgSettings.wizValue;

          // patch pour alimentation correcte des settings
          if(this.currentArg.settingsStr) {
            try {
              this.currentArg.settings = JSON.parse(this.currentArg.settingsStr);
            }
            catch(e: any) {

            } 
          } else {
            this.currentArg.settings = null;
          }

          break;  

        // case this.trsLevelLabel: // libellé du label // LMA les levels sont gérés par leur container
        //   this.currentFDLevel.labelVO.updateTranslationEntry(e.value);
        //   break;
        default:
          // interception des mauvais update
          return;
      }
    }

    if (e.currentTarget === this.vgFDVEdition.elementRef.nativeElement) {
      // maj d'un FDV
      // console.log('update', e.currentTarget, e.target);
      this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
      this.clone.addToUpdatePack(this.currentFDV, EM_ACTION.UPDATE);
    }
    if (e.currentTarget === this.vgFDLEdition.elementRef.nativeElement) {
      // maj d'un FDL
      // console.log('updatelevel', e.currentTarget, e.target);
      this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
    }
    if (e.currentTarget === this.vgEditArgs.elementRef.nativeElement) {
      // maj d'un Args
      this.argsMultiDisplay.agGrid.api.refreshCells();
      this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
    }

    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    this.manageComponents();
  }

  /** modification du filtre sur les FDV */
  private refreshFDVList(e: WizEvent): void {
    this.freedataValueDS.refresh();
  }

  /**
   * Confirmation de création d'un nouveau free data. Si confirmation
   * @param confirmationResult Confirmation de création
   */
  private askForCreate(confirmationResult: ConfirmationResultObj) {
    if (confirmationResult.result === CONFIRMATION_RESULT.CONFIRM) {
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false));
      this.createFD();
    }
  }

  /** Création d'un nouveau free data */
  private createFD(): void {
    this.clone = Model.getInstance().freedataEngine.cloneFD(Model.getInstance().freedataEngine.createFD());
    this.feed();
    this.freedataDS.clearSelection(); // pas de sélection dans la liste
  }

  /**
   * Abandon de saisie
   * @param confirmationResult Confirmation
   */
  private doCancel(confirmationResult: ConfirmationResultObj) {
    if (confirmationResult.result === CONFIRMATION_RESULT.CONFIRM) {
      if (this.clone.exist) {
        this.clone = Model.getInstance().freedataEngine.cloneFD(Model.getInstance().currentEditedFreedata);
        this.feed();
      } else {
        // annulation sur création, plus de sélection
        Model.getInstance().currentEditedFreedata = null;
        this.clone = null;
        this.feed();
      }
    }
  }

  /**
   * Validateur d'unicité du code / shortCode
   */
  public uniqueCodeValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      // Pas de gestion d'erreur si le _clone est null
      if (!this.clone) {
        return null;
      }
      if (this.tiCode.wizValue !== null && this.tiCode.wizValue && this.tiCode.wizValue.length > 0) {
        // CHRONO = mot réservé
        if (this.tiCode.wizValue.toUpperCase() === 'CHRONO') {
          const temp: WizValidationError = {
            wizError: '$.common.keyword.$',
            wizErrorParams: [],
          };
          return [temp];
        }

        // Recherche d'une autre codif avec le même code
        const otherFreedata = Model.getInstance().freedataEngine.getFreedataMap()?.get(this.tiCode.wizValue.toUpperCase());

        // Si une codif existe deja avec le meme code on affiche le message
        if (otherFreedata && otherFreedata.uid !== this.clone.uid) {
          const temp: WizValidationError = {
            wizError: '$.freedata.error.code.unique.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }
      return null;
    };
  }

  /**
   * Fonction de filtre de la liste des freedata values
   * @param item Elément testé pour le filtre
   */
  private fdvFilterFunc(item: FreedataValueVO): boolean {
    if (item.deleted) {
      return false;
    }
    return this.fdValuesFilter.checkVisible(item);
  }

  /**
   * Confirmation de suppression de codification
   * @param confirmationResult Resultat de confirmation
   */
  private deleteFD(confirmationResult: ConfirmationResultObj) {
    if (confirmationResult.result === CONFIRMATION_RESULT.CONFIRM) {
      const freeData: FreeDataVO = confirmationResult.data;
      if (freeData) {
        if (freeData.exist) {
          Model.getInstance().freedataEngine.remove(freeData, this.deleteFDCallback.bind(this));
        } else {
          this.doCancel(confirmationResult);
        }
      }
    }
  }

  /**
   * callback of the remove freedata method
   * @param cmd Commande de suppression
   */
  private deleteFDCallback(bddPersist: FreeDataVO, status: string): void {
    if (status === WIZ_COMMAND_STATE.SUCCESS) {
      this.freedataDS.removeItem(bddPersist);

      if (bddPersist.code === this.clone.code) {
        // en cas de suppression de l'élément en cours
        Model.getInstance().currentEditedFreedata = null;
        this.clone = null;
        this.feed();
      }
      // this.freedataDS.refresh();
    } else {
      // informe l'utlisateur que la suppression s'est mal passée
      WizPopUp.toast('$.common.toast.service.error.$', WizIcon.TOAST_ERROR).show();
    }
  }

  /** demande de changement de sélection */
  private askSelectFD(e: WizEvent = null): void {
    const vo: FreeDataVO = e.value;
    if (ViewData.wizUpdateModel) {
      if (this.freedataDS.isSelected(vo)) {
        // sélection self, rien
        e.preventDefault();
        return;
      }
      e.preventDefault(); // sélection pas self && modifs en cours

      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.common.pending.update.detail.$',
        this.confirmSelect.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        vo,
        null,
        null
      ).show();
    } else {
      if (!this.freedataDS.isSelected(vo)) {
        // pas encore sélectionné
        this.doSelect(vo);
      } else {
        // déjà sélectionné, déselection
        this.doSelect(null);
      }
    }
  }

  /**
   * Confirmation de la sélection du free data
   */
  private confirmSelect(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      const freedata: FreeDataVO = result.data;
      this.freedataDS.toggle(freedata); // on a prevent l'event, on joue l'action
      this.doSelect(freedata);
    }
  }

  /**
   * Changement de free data sélectionné
   * @param pEvent WizEvent
   */
  private doSelect(vo: FreeDataVO) {
    // this.freedataDS.toggle(vo);

    // if (this.freedataDS.selectedItem) { // pas le même
    // if (this.clone && this.clone.code  && this.clone && this.freedataDS.selectedItem.code === this.clone.code)
    // Rinçage du filte des features à la sélection d'un rôle
    this.fdValuesFilter.resetFilter();
    Model.getInstance().currentEditedFreedata = vo;

    this.feed();
    // }
  }

  /* ################################################
                      gestion des FDV
    ################################################ */

  /** modification du code du FDV en cours de création */
  public askForFDVCode(): void {
    const pop: WizPopUp = new WizPopUp(
      FreedataValueCodePop,
      false,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      '220px',
      '170px',
      [this.clone, this.currentFDV, this.updateFDVCode.bind(this)]
    );
    // TODO position près du wizIcon
    pop.show();
  }


  /** modification du code d'un FDV en cours d'ajout */
  private updateFDVCode(fdv: FreedataValueVO, newCode: string): void {
    this.deleteFDV(fdv);
    fdv.code = newCode;
    // console.log('newCode', fdv.code);
    this.currentFDV = fdv;
    this.clone.addFreeDataValue(fdv);
    // console.log('add FDV', newFdv);
    this.feedFreedataValues(); // alimentation de la collection (pas subtil, pourrait faire ADD sur la DS)
    this.freedataValueDS.select([fdv]); // ??
    this.feedFDVFields();

    // this.addFDV(null);
  }


  /** demande de changement de sélection de FDV. Ok si pas d'erreur dans le FDV en cours ? */
  private askSelectFDV(e: WizEvent = null): void {
    const vo: FreedataValueVO = e.value;

    const errors = this.currentFDV ? this.vgEditValueContainer.check(true, true) : null;
    if (errors && errors.length > 0) {
      WizPopUp.toast('$.common.toast.pending.error.$', WizIcon.TOAST_ERROR).show();
      // console.log('errors on fields', this.currentFDV);
      e.preventDefault();
    }
    // }
  }

  /**
   * Sélection d'un freedataValue dans le tree. Potentiellement intercepté par askSelectFDV (capture onChanging)
   * @param pEvent, wizEvent contenant la valeur
   */
  private selectFDV(pEvent: WizEvent): void {
    this.currentFDV = pEvent.value && pEvent.value.length > 0 ? pEvent.value[0] : null;
    this.feedFDVFields();
  }


  public fdvExist(): boolean {
    return !!this.currentFDV?.exist;
  }

  /**
   * Alimentation du formulaire d'édition des FDV
   * @param freedataValue Element édité
   */
  private feedFDVFields() {
    if (this.currentFDV) {
      // console.log('fields start', this.currentFDV);
      const fdvVO: FreedataValueVO = this.currentFDV;

      this.tiValueShortCode.wizValue = fdvVO.shortCode;
      this.tiValueCode.wizValue = this.currentFDV.code; // alimentation du code pour info
      this.trsValueLabel.translationData = Model.getInstance().localeEngine.buildTranslationData(fdvVO.labelVO);
      this.trsValueDesc.translationData = Model.getInstance().localeEngine.buildTranslationData(fdvVO.descriptionVO);
      this.tiValueValue.wizValue = fdvVO.valor;
      this.tiValueExternalCode.wizValue = fdvVO.externalCode;
      this.tiValueExternalParentCode.wizValue = fdvVO.externalParentCode;

      this.tiValueRestrict.wizValue = fdvVO.restrict;
      this.cbValueDeprecated.wizChecked = fdvVO.deprecated;
      this.niOrder.wizNumber = fdvVO.order;


      this.dfValueStartDate.wizNumberValue = fdvVO.startDate;
      this.dfValueEndDate.wizNumberValue = fdvVO.endDate;
      this.dfValueStartDate.wizMaxDate = this.dfValueEndDate.wizDateValue;
      this.dfValueEndDate.wizMinDate = this.dfValueStartDate.wizDateValue;
      this.uploadFDV.sourceObservable = fdvVO.iconOrDie;

      WizFocusManager.getInstance().wizSetFocus(this.tiValueShortCode);
      this.showFDVEditZone = true;
    } else {
      this.showFDVEditZone = false;
    }
    this.manageFDVLevels(); // gestion des niveaux de FDVs

    // console.log('fields end', this.currentFDV);
    this.feedFDVArgs(); // et alimentation de la zone "champs complémentaires"
  }

  /** ajout d'un FDV de 1er niveau (depuis le +) */
  public addFirstLevelFDV(): void {
    this.addFDV(null);
  }



  /**
   * Ajout d'un free data value
   * @param e Evenement ajout
   */
  private addFDV(e: AlkEvent): void {
    if (e) {
      e.preventDefault();
    }

    const errors = this.currentFDV ? this.vgEditValueContainer.check(true, true) : null;
    if (!errors || errors.length === 0) {
      const parent: FreedataValueVO = e ? e.data : null;
      const newFdv = Model.getInstance().freedataEngine.createFreeDataValue(this.clone, parent);
      this.currentFDV = newFdv;
      this.clone.addFreeDataValue(newFdv);
      // console.log('add FDV', newFdv);
      this.feedFreedataValues(); // alimentation de la collection (pas subtil, pourrait faire ADD sur la DS)
      this.freedataValueDS.select([newFdv]); // ??
      if (!!parent) {
        this.freedataValueDS.expandNode(parent);
      }

      this.feedFDVFields();

      // this.clone.addToUpdates(this.currentFDV, EM_ACTION.CREATE );
      this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
      //WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
      ViewData.wizUpdateModel = true;
      this.manageComponents();
    } else {
      WizPopUp.toast('$.common.toast.pending.error.$', WizIcon.TOAST_ERROR).show();
    }
  }

  /**
   * demande de suppression d'une freedata value depuis le le tree
   * @param e evenement allkeyme
   */
  private askdeleteFDV(e: AlkEvent): void {
    e.preventDefault();
    this.deleteFDV(e.data);
  }

  /**
   * Suppression d'un free data value
   * @param fdv le FDV à supprimer
   */
  private deleteFDV(fdv: FreedataValueVO): void {
    Model.getInstance().freedataEngine.deleteFDV(this.clone, fdv); // va tracer les modifs dans la collection d'update du clone
    this.currentFDV = null; // on rince la sélection
    this.freedataValueDS.clearSelection();

    this.feedFreedataValues();
    this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    this.manageFDVLevels();
    this.manageComponents();
  }

  /** alimente le FDV (sur select)  */
  private manageFDVLevels() {
    // TODO, plus sélectif. Construction 1 fois, ajout si besoin.
    this.currentFDLevel = null; // on alimente le level en cours
    if (this.currentFDV) {
      // this.currentFDLevel = this.clone.getFreeDataLevel(this.currentFDV.level);
      this.currentFDLevel = Model.getInstance().freedataEngine.getFreeDataLevel(this.clone, this.currentFDV.level);
      // console.log('lvl', this.currentFDLevel, this.currentFDV.level, this.clone);
      if (!this.currentFDLevel) {
        // this.clone.addFreeDataLevel(this.currentFDLevel);
        this.currentFDLevel = Model.getInstance().freedataEngine.createFreedatalevel(this.clone, this.currentFDV.level);
        Model.getInstance().freedataEngine.addFreeDataLevel(this.clone, this.currentFDLevel);
        // ajout du flag sur le FD pour maj
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
      }
    }

    this.clearLevels();

    // prise du nombre de levels
    const nbLevel: number = this.getMaxLevel();
    if (nbLevel >= 1) {
      this.clone.levelsVO.forEach((lvlVO: FreedataLevelVO) => {
        if (lvlVO.level <= nbLevel) {
          const meCompo: ComponentRef<FDLevelRenderer> = WizComponentManager.instance.addChildTo(
            FDLevelRenderer,
            this.containerLevels,
            { instanceProperties: { data: lvlVO } }
          );
          this.lvlComponents.push(meCompo);
        }
      });
    }
  }

  /** retour de dataCommit */
  private mergeFromDataCommit(csp: CompositeSourcePack): void {
    this.freedataDS.refresh(); // refresh si changement de libellé

    // console.log('args', this.clone.getArgsVO());
    let code: string = null;
    if (this.currentFDV) {
      code = this.currentFDV.code;
    }

    this.feed(code); // refresh de la zone d'édition avec recréation du clone
  }

  /**
   * Retour de service merge
   * @param  bddPersist: FreeDataVO
   * @param status le statut de retour du service
   * @return boolean: vrai si la comande est en succes
   */
  private mergeCallback(bddPersist: FreeDataVO, status: string): void {
    // console.log('back from FD 1rst')
    if (status === WIZ_COMMAND_STATE.SUCCESS) {
      // const fdMap: Map<string, FreeDataVO> = new Map(this.freedataDS.getSource().map(item => [item.code, item]));
      if (bddPersist.operation === EM_ACTION.CREATE) {
        Model.getInstance().currentEditedFreedata = bddPersist; // mise à jour du "vrai" en cours
        this.freedataDS.addItem(Model.getInstance().currentEditedFreedata);
        this.freedataDS.toggle(Model.getInstance().currentEditedFreedata);
        this.cdref.markForCheck();
      } else if (bddPersist.operation === EM_ACTION.UPDATE) {
        Model.getInstance().currentEditedFreedata = bddPersist; // mise à jour du "vrai" en cours
        this.freedataDS.itemUpdated([Model.getInstance().currentEditedFreedata]);
      } else {
        // delete
        Model.getInstance().currentEditedFreedata = null;
        this.freedataDS.removeItem(bddPersist);
        this.freedataDS.clearSelection();
      }
      this.freedataDS.refresh(); // refresh si changement de libellé

      let code: string = null;
      if (this.currentFDV) {
        code = this.currentFDV.code;
      }

      this.feed(code); // refresh de la zone d'édition avec recréation du clone

    } else { // fault, défaut sur synchro
      ViewData.wizUpdateModel = false;
      this.deleteFDCallback(Model.getInstance().currentEditedFreedata, WIZ_COMMAND_STATE.SUCCESS)
    }
  }


  /**
   * Validateur d'unicité du shortCode d'un FDV
   */
  public uniqueShortCodeValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      if (!this.currentFDV) {
        // Pas de gestion d'erreur si le _clone est null
        return null;
      }

      for (const vo of this.clone.getValuesVO()) {
        // si un autre freedatavalue de uid différent, de même parent a le même shortCode, on affiche un message d'erreur
        if (
          vo.uid !== this.currentFDV.uid && // pas moi
          (vo.parentCode === this.currentFDV.parentCode || // même parent ou pas de parent (root)
            (WizStringUtils.isEmpty(vo.parentCode) && WizStringUtils.isEmpty(this.currentFDV.parentCode))) &&
          vo.shortCode === this.currentFDV.shortCode
        ) {
          // et même shortCode... Problème
          const temp: WizValidationError = {
            wizError: '$.freedatavalue.error.shortcode.unique.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }
      return null;
    };
  }

  /* ################################################
                      gestion des medias
    ################################################ */

  /**
   * Demande de chargement d'une image
   * @param target FD pour l'icone du FD, FDV pour l'icone d'un FDV
   */
  public clickForUpload(target: string): void {
    
    let params: ImageUploadParameter = {
      component: null,
      elementRef: null,
      dom: this.clone.domain,
      bu: this.clone.businessUnitCode,
      vision: ViewData.wildcardMainVision
    }
    
    if (target === 'FD') {
      params.component = this.uploadFD;
      params.elementRef = this.uploadFD.elementRef;
    } else {
      params.component = this.uploadFDV;
      params.elementRef = this.uploadFDV.elementRef;
    }
    Model.getInstance().batchEngine.loadImage(params);
  }

  /**
   * demande d'ouverture sur l'image picker par clavier; touche entrée ou espace
   * @param event event clavier
   * @param target FD pour l'icone du FD, FDV pour l'icone d'un FDV
   */
  public keydownForUpload(event: KeyboardEvent, target: string): void {
    const isEnterKey = event.key === VALUE_ENTER; // touche entrée
    const isSpaceKey = event.code === CODE_SPACE; // touche espace
    if (isEnterKey || isSpaceKey) {
      this.clickForUpload(target);
    }
  }

  /* ################################################
                gestion des levels
   ################################################ */

  /** retourne le niveau max pour les FDVs */
  private getMaxLevel(): number {
    let result: number = 0;
    if (!!this.clone && !!this.clone.getValuesVO()) {
      this.clone.getValuesVO().forEach((item) => {
        if (item.level > result) {
          result = item.level;
        }
      });
    }
    return result;
  }

  /** suppression des champs de saisie Level */
  private clearLevels(): void {
    if (!!this.lvlComponents && this.lvlComponents.length > 0) {
      this.containerLevels.clear(); // vider le container
      this.lvlComponents = []; // on rince la référence aux saisies de levels
    }
  }

  /* ################################################
            gestion des médias / exports
   ################################################ */

  /** affichage de l'icone de suppression des... icones */
  public hasImage(who: string): boolean {
    return (who === 'FD' && !!this.clone?.icon) || (who === 'FDV' && !!this.currentFDV?.icon);
  }

  /**  de suppression des... icones */
  public clearImage(who: string): void {
    if (who === 'FD') {
      this.clone.icon = null;
      this.uploadFD.sourceObservable = this.clone.iconOrDie;
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    } else if (who === 'FDV') {
      // this.currentFDV.icon = null;
      // this.uploadFDV.sourceObservable = this.currentFDV.iconOrDie;  
      // WizEventManager.dispatchEvent(this.clearFDV.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
      WizEventManager.dispatchEvent(this.clearFDV.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.clearFDV, null));


      
    }
    
    this.manageComponents();
  }

  /** delete autorisé ? */
  public canDelete(): boolean {
    let result: boolean = true;
    if (this.clone && this.clone.kindMeasure) {
      result = !Model.getInstance().visionEngine.checkMeasureIsUsedForFD(this.clone.code);
    }
    return result;
  }

  /** callback sur retour d'import : recharger les Freedatas */
  private backFromImport(e: AlkEvent): void {
    // console.log('backFromImport',e);
    if (e && (e.data === BATCH_KIND.FREEDATA || e.data === BATCH_KIND.FREEDATAARGS)) {
      WizCommandManager.setLock(true);
      setTimeout(() => {
        Model.getInstance().syncService.clearFD();
        Model.getInstance().syncService.clearFEI();
        Model.getInstance().compositeEngine.compositeReload();
      }, (0));
    }
  }

  /** fredatas rechargés, refresh de la vue */
  private backFromReload(e: any): void {
    // console.log('backFromReload',e); 
    Model.getInstance().currentEditedFreedata = null;
    this.wizSynchronizeData();
  }

  /* ################################################
  gestion des champs supplémentaires (sur le FREEDATA)
  ################################################ */

  /** Alimentation de la DS des args */
  private feedArgsValues(): void {
    if (!!this.clone) {
      this.freedataArgsDS.setSource(this.clone.getArgsVO());
    } else {
      this.freedataArgsDS.setSource([]);
    }
  }

  /**
   * Validateur d'unicité du shortCode d'un Args
   */
  // public uniqueArgCodeValidator(): WizValidatorFn {
  //   return (): WizValidationErrors | null => {
  //     if (!this.currentArg) {
  //       // Pas de gestion d'erreur si le _clone est null
  //       return null;
  //     }

  //     for (const vo of this.clone.argsVO) {
  //       if ( vo.uid !== this.currentArg.uid &&  vo.code === this.currentArg.code
  //          // TODO interdire les champs de base (code, label...)
  //          ) {
  //         // et même code... Problème
  //         const temp: WizValidationError = {
  //           wizError: '$.freedataarg.error.code.unique.$',
  //           wizErrorParams: [],
  //         };
  //         return [temp];
  //       }
  //     }
  //     return null;
  //   };
  // }


  /**
   * contrôle l'arg en cours, return true si une erreur
   */
  private checkArgError(): boolean {
    if (this.currentArg) {
      const errors = this.vgEditArgsContainer.check(true, true);
      if (errors?.length > 0) {
        WizPopUp.toast('$.arg.errors.$', WizIcon.TOAST_ERROR).show();
        return true;
      }
    }
    return false;
  }


  /** demande de changement de sélection dans le tableau de champs complémentaires */
  private askSelectArg(e: WizEvent = null): void {

    if (this.checkArgError()) { // si pas d'erreur en cours seulement
      e.preventDefault();
      return;
    }
    const vo: FreedataArgsVO = e.value;
    if (!this.freedataArgsDS.isSelected(vo)) {
      this.doSelectArg(vo);  // pas encore sélectionné
    } else {

      this.doSelectArg(null); // déjà sélectionné, déselection
    }

  }

  /**
   * Changement d'arg
   * @param vo l'arg (ou vide)
   */
  private doSelectArg(vo: FreedataArgsVO) {
    this.currentArg = vo;
    this.feedArgFields();
  }

  /**
   * Alimentation du formulaire d'édition des args (du FREEDATA)
   * @param FreedataArgsVO Element édité
   */
  private feedArgFields() {
    this.tiArgShortCode.wizRestrict = ViewData.CODE_REGEXP;

    if (!!this.currentArg) {
      this.tiArgShortCode.wizValue = this.currentArg.code;
      this.trsArgLabel.translationData = Model.getInstance().localeEngine.buildTranslationData(this.currentArg.labelVO);
      this.trsRestrictMsg.translationData = Model.getInstance().localeEngine.buildTranslationData(this.currentArg.editRestrictMessageVO);
      this.trsValueControlMsg.translationData = Model.getInstance().localeEngine.buildTranslationData(this.currentArg.valueControlMessageVO);

      let typ: FakeVO = null; // le type en forme "objet"
      if (this.currentArg.dataType) {
        typ = this.argsDatatypeDS.getItemByKey(this.currentArg.dataType);
      }
      this.argsDatatypeDS.select([typ]);

      this.argsFormatDS.setSource(Model.getInstance().formatEngine.getFormatList());
      this.argsFormatDS.refresh(); // réactualiser la liste des formats
      let format: FormatVO = null; // le format de données
      if (this.currentArg.format) {
        const formatSplit: string[] = this.currentArg.format.split(ViewData.KEY_SEPARATOR);
        format = Model.getInstance().formatEngine.getFormat(formatSplit[0], formatSplit[1]);
      }
      this.argsFormatDS.select([format]);

      this.tiArgRestrict.wizValue = this.currentArg.restrict;
      this.tiArgLock.wizValue = this.currentArg.lock;
      this.tiArgValidator.wizValue = this.currentArg.validator;
      this.tiArgSource.wizValue = this.currentArg.datas;
      this.tiArgDefaultValue.wizValue = this.currentArg.valor;
      this.tiArgDefaultTrigger.wizValue = this.currentArg.valorTrigger;
      this.tiMinVal.wizValue = this.currentArg.minValue;
      this.tiMaxVal.wizValue = this.currentArg.maxValue;
      this.niArgSize.wizNumber = this.currentArg.defaultSize;
      this.tiArgAction.wizValue = this.currentArg.action;
      
      // génération du settings en mode string
      if(this.currentArg.settings) {
        this.currentArg.settingsStr = JSON.stringify(this.currentArg.settings);
      }
      this.taArgSettings.wizValue = this.currentArg.settingsStr;
      this.tiRegex.wizValue = this.currentArg.regex;
      this.cbUpper.wizChecked = this.currentArg.upper;

      setTimeout(() => {
        WizFocusManager.getInstance().wizSetFocus(this.tiArgShortCode);
      }, 0);
    }
    this.cdref.markForCheck();
  }

  /** ajout d'un args (au FREEDATA) */
  public newArgs(): void {

    if (!this.checkArgError()) { // si pas d'erreur en cours
      this.askForArgCode();
    }
  }

  /**
   * Suppression d'un arg (au FREEDATA)
   * @param fdv le arg à supprimer
   */
  private deleteArg(cro: ConfirmationResultObj): void {
    Model.getInstance().freedataEngine.deleteArg(this.clone, cro.data); // va supprimer la source et le VO
    this.currentArg = null; // on rince la sélection
    this.freedataArgsDS.refresh(); // refresh de la DS pour refresh du grid
    this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    this.manageComponents(); // refresh des bts save / cancel
  }


  /* ################################################
      gestion des Args sur les FREEDATA_VALUES
   ################################################ */

  /** les champs de saisie des args du FDV */
  public argComponents: ComponentRef<ArgsRenderer>[] = [];

  /** modification du code du FDV en cours de création */
  public askForArgCode(): void {
    const pop: WizPopUp = new WizPopUp(
      ArgAddPop,
      false,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      '300px',
      '170px',
      [this.clone, this.updateArgCode.bind(this)]
    );
    // TODO position près du wizIcon
    pop.show();
  }


  /** ajout d'un arg, son code est OK */
  private updateArgCode(newArgVO: FreedataArgsVO): void {

    Model.getInstance().freedataEngine.addArg(this.clone, newArgVO);
    this.freedataArgsDS.refresh(); // forcer le refresh pour affichage du args

    this.freedataArgsDS.select([newArgVO]);
    this.doSelectArg(newArgVO);

  }


  /**
   * alimentation de la zone "champs complémentaires" du FDV
   */
  private feedFDVArgs(): void {
    // console.log('args start', this.currentFDV);
    this.clearArgs();
    // console.log('args end clear', this.currentFDV);
    if (this.currentFDV) {
      this.clone.getArgsVO().forEach((argvo: FreedataArgsVO) => {
        const meCompo: ComponentRef<ArgsRenderer> = WizComponentManager.instance.addChildTo(
          ArgsRenderer,
          this.containerFdvArgs,
          { instanceProperties: { data: { arg: argvo, fdv: this.currentFDV, model: Model.getInstance(), fdvView: true } } }
        );
        this.argComponents.push(meCompo);
      })
    }
    // console.log('args end', this.currentFDV);
  }

  /** suppression des "champs complémentaires" du FDV */
  private clearArgs(): void {
    if (!!this.argComponents && this.argComponents.length > 0) {
      this.containerFdvArgs.clear(); // vider le container
      this.argComponents = []; // on rince la référence aux saisies de levels
    }
  }

}
